import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import {
  MatPaginator,
  MatPaginatorModule,
  PageEvent,
} from '@angular/material/paginator'
import { MatTableDataSource, MatTableModule } from '@angular/material/table'
import { MatIconModule } from '@angular/material/icon'

import { TranslationService } from '../../../../../services/translation.service'
import { BulkProductShareCsvRow } from '../../../../../types/products'

@Component({
  selector: 'app-review-shared-products',
  standalone: true,
  imports: [MatTableModule, MatPaginatorModule, MatButtonModule, MatIconModule],
  templateUrl: './review-shared-products.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './review-shared-products.component.scss',
})
export class ReviewSharedProductsComponent implements OnChanges {
  translationService = inject(TranslationService)

  @Input({ required: true }) rows: Array<BulkProductShareCsvRow> = []

  @Output() confirmed = new EventEmitter<void>()

  displayedColumns: string[] = [
    'productIdentifier',
    'companyName',
    'overrideProductSupplier',
    'overrideComponentSuppliers',
    'productResolved',
    'companyValid',
    'connectedInSupplyChain',
    'alreadyShared',
  ]

  dataSource = new MatTableDataSource<BulkProductShareCsvRow>([])

  pageSizeOptions: number[] = [5, 10, 25, 50]
  pageSize = 10

  @ViewChild(MatPaginator) paginator?: MatPaginator

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rows']) {
      this.dataSource.data = this.rows

      if (this.paginator) {
        this.dataSource.paginator = this.paginator
      }
    }
  }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp
    this.dataSource.paginator = mp
  }

  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize
  }

  isRowValid(row: BulkProductShareCsvRow): boolean {
    // Already-shared rows are allowed (they'll be treated as a no-op on submit).
    return row.productResolved && row.companyValid && row.connectedInSupplyChain
  }

  isRowBlocking(row: BulkProductShareCsvRow): boolean {
    return (
      !row.productResolved || !row.companyValid || !row.connectedInSupplyChain
    )
  }

  getValidRowCount(): number {
    return (this.dataSource.data ?? []).filter((r) => this.isRowValid(r)).length
  }

  getTotalRowCount(): number {
    return (this.dataSource.data ?? []).length
  }

  isAllValid(): boolean {
    const total = this.getTotalRowCount()
    if (total === 0) return false

    return (this.dataSource.data ?? []).every((r) => !this.isRowBlocking(r))
  }

  confirm(): void {
    this.confirmed.emit()
  }
}
